export default __webpack_public_path__ + "static/media/limite-atingido.5fc62ca5.svg";